import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import metadata from './block.json';

/**
 * Internal dependencies
 */
import Edit from './edit';
import Save from './save';

// import attributes
import attributes from './attributes';
import { TeamMemberIcon } from './icon';



/**
 * Block Registration
 */

registerBlockType(metadata.name, {
	...metadata,
	icon: {
		src: TeamMemberIcon,
		foreground: '#1D0BCE',
	},
	attributes,
	edit: Edit,
	save: Save,
});
